import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
const store = new Vuex.Store({
    state: {
        token: JSON.parse(localStorage.getItem("userInfo")) != null ? JSON.parse(localStorage.getItem("userInfo")).token : "",
        to: {},
        from: {},
        tabNum: 0,
        flag: false,//超时判断
        show:false,
        shows:false,
        userInfo: JSON.parse(localStorage.getItem("userInfo")) != null ? JSON.parse(localStorage.getItem("userInfo")) : "",
        buyerId: JSON.parse(localStorage.getItem("userInfo")) != null ? JSON.parse(localStorage.getItem("userInfo")).buyerId : "",
        timer:"",
        flage: false,//首页炸屏
        flage1: false,//判断首页炸屏
        flags: false,//判断是否展示客服
        flag1: false,//判断是否隐藏客服
        kfNum: 0,//客服提示数
        kefuNum: 0,//客服提示数
        timers: "",//客服提示
        timers1: "",//客服提示
        SchoolNum:0,
        back: false,
        informationFlag: false,
        objs:{
            show:false
        },
		originNum:0,  //原药材

    },
    mutations: {
        tabs(state, option) {
            state[option.key] = option.value;
        }
    },
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js